import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Chart } from "./components/chart/Chart";
import { ChartData } from "./types";

type Props = {
  data: ChartData[];
};

export const DistributionGraph: FC<Props> = ({ data }) => {
  const { t } = useTranslation("performance-graphs");

  return (
    <div className={classNames("w-full space-y-12")}>
      <div className="space-y-1">
        <h4
          className={classNames(
            "flex items-center gap-x-5 text-medium text-primary-content",
          )}
        >
          {t("distributionGraphTitle")}
        </h4>
        <p className={classNames("text-regular text-base-400")}>
          {t("distributionGraphSubtitle")}
        </p>
      </div>
      <Chart series={data} />
      <p
        className={classNames(
          "w-full text-center text-extra-small text-base-400",
          "xxl:text-regular",
        )}
      >
        {t("distributionGraphLegend")}
      </p>
    </div>
  );
};
